<script>
import Vue from 'vue'
import {mapActions} from "vuex";

export default Vue.extend({
  name: "enquiryTable",
  data() {
    return {
      totalConciergeEnquiries: 0,
      pageConciergeEnquiries: 1,
      sizeConciergeEnquiries: 25,
      conciergeEnquiries: [],
    }
  },
  methods: {
    ...mapActions("enquiry", ["getConciergeEnquiries"]),
    retrieveConciergeEnquiryList() {
      let params = {
        page: this.pageConciergeEnquiries,
        size: this.sizeConciergeEnquiries,
      }
      this.getConciergeEnquiries({params: params, callback: this.callback})
    },
    truncateQuestion(value) {
      if (value && value.length > 25) {
        return value.substring(0, 25) + '...';
      }
      return value;
    },
    getFullName(value) {
      return value.firstName + ' ' + value.lastName
    },
    getFullAddress(value) {
      return value.firstName + ' ' + value.lastName
    },
    showPropertyDetail(key, val) {
      if (key == 1) {
        this.$router.push({path: '/uconnect/view', query: {pid: val.propertyId}})
      }
    },
    handleCurrentChange(val) {
      this.pageConciergeEnquiries = val
      this.getConciergeEnquiries()
    },
    callback(resp, status) {
      switch (status) {
        case 'getConciergeEnquiriesCallback':
          console.log('getConciergeEnquiriesCallback: ', resp.data.list)
          if (resp.code == 0) {
            this.totalConciergeEnquiries = resp.data.totalRecord
            this.conciergeEnquiries = resp.data.list
          } else {
            Utils.alert('', resp.message, 'error')
          }
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    this.retrieveConciergeEnquiryList()
  },
})
</script>

<template>
  <div>
    <el-table
      :data="conciergeEnquiries"
      style="width: 100%;">
      <el-table-column
        prop="firstName"
        min-width="150"
        label="Name">
        <template v-slot="scope">
          <span>{{ getFullName(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="email"
        min-width="200"
        label="Email">
      </el-table-column>
      <el-table-column
        prop="phoneNumber"
        min-width="250"
        label="Phone Number">
      </el-table-column>
      <el-table-column
        prop="propertyAddress"
        min-width="150"
        label="Property Address">
        <template v-slot="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.propertyAddress" placement="right">
            <span>{{ truncateQuestion(scope.row.propertyAddress) }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="nominatedClientName"
        min-width="150"
        label="Nominated Client Name">
      </el-table-column>
      <el-table-column
        prop="question"
        min-width="200"
        label="Question">
        <template v-slot="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.question" placement="right">
            <span>{{ truncateQuestion(scope.row.question) }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="propertyId"
        min-width="250"
        label="Actions">
        <template v-slot="scope">
          <el-button class="btn-link" @click="showPropertyDetail(1,scope.row)" type="text" icon="el-icon-view">View
            Property
          </el-button>
<!--          <span class="divider"> | </span>-->
<!--          <el-button class="btn-link" @click="handleDelete(scope.row)" type="text" icon="el-icon-delete">Remove-->
<!--          </el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <div class="fen" v-if="totalConciergeEnquiries">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="pageConciergeEnquiries"
        :page-size="25"
        layout="total, prev, pager, next"
        :total="totalConciergeEnquiries">
      </el-pagination>
    </div>
  </div>
</template>

<style scoped lang="scss">
.btn-link {
  color: rgba(0, 51, 51, 0.9);
  font-family: 'DINosaur-a', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline;
}

.btn-link:hover {
  color: #003333;
}
</style>



// WEBPACK FOOTER //
// src/components/enquiry/enquiryTable.vue